export default class SpecificBodyPartEntity {
    specificBodyPartId: number;
    specificBodyPartName: string;
}